"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const material_1 = require("@mui/material");
const merge_1 = require("merge");
const Loading_1 = require("../Loading");
const Button_styles_1 = require("./Button.styles");
const Button = (props) => {
    const { children, icon, loading } = props, rest = __rest(props, ["children", "icon", "loading"]);
    const { buttonStyles } = (0, Button_styles_1.default)();
    const getIcon = () => {
        if (props.startIcon) {
            return props.startIcon;
        }
        return (0, jsx_runtime_1.jsx)(icons_material_1.ChevronRightOutlined, {});
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({}, rest, { startIcon: !loading && icon && icon === 'left' ? getIcon() : null, endIcon: !loading && icon && icon === 'right' ? getIcon() : null, sx: (0, merge_1.merge)(true, buttonStyles, props.sx), children: loading ? ((0, jsx_runtime_1.jsx)(Loading_1.default, { color: props.variant })) : children ? ((0, jsx_runtime_1.jsx)("span", { className: "wrapper", children: children })) : ('Button') })));
};
exports.default = Button;
